export const manifest = {
  screens: {
    scr_tidbso: { name: "Product Blueprint", route: "/", position: {"x":160,"y":1820} },
    scr_xwq1t5: { name: "Dashboard", route: "/app", position: {"x":160,"y":3800} },
    scr_vd3iaw: { name: "Assessments", route: "/app/assessments", position: {"x":1560,"y":3800} },
    scr_ejn4ze: { name: "Respondent Management", route: "/app/respondents", position: {"x":11360,"y":3800} },
    scr_dhwjrm: { name: "Reports & Insights", route: "/app/reports", position: {"x":2960,"y":3800} },
    scr_k9wf3b: { name: "Directory", route: "/app/team", position: {"x":4360,"y":3800} },
    scr_p64lkf: { name: "Settings", route: "/app/settings", position: {"x":5760,"y":3800} },
    scr_stzi8z: { name: "User Profile", route: "/app/profile", position: {"x":7160,"y":3800} },
    scr_y5z2hm: { name: "Competency Domains", route: "/app/competencies", position: {"x":8560,"y":3800} },
    scr_s6vv63: { name: "Question Library", route: "/app/questions", position: {"x":9960,"y":3800} },
    scr_lq4uks: { name: "Scoring Dashboard", route: "/app/scoring", position: {"x":12760,"y":3800} },
    scr_bi4fzq: { name: "AI Insights", route: "/app/insights", position: {"x":14160,"y":3800} },
    scr_c1cqh7: { name: "Administration", route: "/app/admin", position: {"x":16960,"y":3800} },
    scr_spxecj: { name: "Design System", route: "/app/design-system", position: {"x":160,"y":11720} },
    scr_o0ot1b: { name: "Database Schema", route: "/app/schema", position: {"x":1560,"y":11720} },
    scr_9yn99i: { name: "Login", route: "/login", position: {"x":160,"y":5780} },
    scr_e83lma: { name: "Register", route: "/register", position: {"x":1560,"y":5780} },
    scr_kv6lds: { name: "Forgot Password", route: "/forgot-password", position: {"x":2960,"y":5780} },
    scr_4npjbu: { name: "Verify Email", route: "/verify-email", position: {"x":4360,"y":5780} },
    scr_wtecss: { name: "Assessment · Welcome", route: "/assessment", state: {"step":0,"anonymous":true}, position: {"x":160,"y":9740} },
    scr_193j2f: { name: "Assessment · Instructions", route: "/assessment", state: {"step":1,"anonymous":true}, position: {"x":1560,"y":9740} },
    scr_zuewe3: { name: "Assessment · First Domain", route: "/assessment", state: {"step":2,"anonymous":true}, position: {"x":2960,"y":9740} },
    scr_feq1sx: { name: "Assessment · Last Domain", route: "/assessment", state: {"step":13,"anonymous":true}, position: {"x":4360,"y":9740} },
    scr_69qofc: { name: "Assessment · Completion", route: "/assessment", state: {"step":14,"anonymous":true}, position: {"x":7160,"y":9740} },
    scr_il93d5: { name: "New Assessment · Details", route: "/app/assessments/new", state: {"step":1}, position: {"x":160,"y":7760} },
    scr_tt4b52: { name: "New Assessment · Type & Role", route: "/app/assessments/new", state: {"step":2,"role":"ceo"}, position: {"x":1560,"y":7760} },
    scr_8qlowz: { name: "New Assessment · Competency Domains", route: "/app/assessments/new", state: {"step":3,"role":"ceo"}, position: {"x":2960,"y":7760} },
    scr_0bqw3s: { name: "New Assessment · Select Questions", route: "/app/assessments/new", state: {"step":4,"role":"ceo"}, position: {"x":4360,"y":7760} },
    scr_zob9u7: { name: "New Assessment · Rating Scale", route: "/app/assessments/new", state: {"step":5,"role":"ceo","sampleSelection":true}, position: {"x":7160,"y":7760} },
    scr_au3xjp: { name: "New Assessment · Invite Respondents", route: "/app/assessments/new", state: {"step":6,"role":"ceo","sampleSelection":true}, position: {"x":8560,"y":7760} },
    scr_tiz0d1: { name: "New Assessment · Review", route: "/app/assessments/new", state: {"step":7,"role":"ceo","sampleSelection":true}, position: {"x":9960,"y":7760} },
    scr_6zm0m0: { name: "New Assessment · Launch", route: "/app/assessments/new", state: {"step":8,"role":"ceo","sampleSelection":true}, position: {"x":11360,"y":7760} },
  },
  sections: {
    sec_qi87hl: { name: "Landing & Entry", x: 0, y: 1600, width: 2920, height: 1180 },
    sec_1hax7j: { name: "App Features", x: 0, y: 3580, width: 19720, height: 1180 },
    sec_dcyvxh: { name: "Authentication", x: 0, y: 5560, width: 5720, height: 1180 },
    sec_5bzho2: { name: "New Assessment Creation", x: 0, y: 7540, width: 12720, height: 1180 },
    sec_z8y2qt: { name: "Assessment Respondent Flow", x: 0, y: 9520, width: 8520, height: 1180 },
    sec_e6dn01: { name: "Development & Reference", x: 0, y: 11500, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_qi87hl", children: [
      { kind: "screen", id: "scr_tidbso" },
    ] },
    { kind: "section", id: "sec_1hax7j", children: [
      { kind: "screen", id: "scr_xwq1t5" },
      { kind: "screen", id: "scr_vd3iaw" },
      { kind: "screen", id: "scr_dhwjrm" },
      { kind: "screen", id: "scr_k9wf3b" },
      { kind: "screen", id: "scr_p64lkf" },
      { kind: "screen", id: "scr_stzi8z" },
      { kind: "screen", id: "scr_y5z2hm" },
      { kind: "screen", id: "scr_s6vv63" },
      { kind: "screen", id: "scr_ejn4ze" },
      { kind: "screen", id: "scr_lq4uks" },
      { kind: "screen", id: "scr_bi4fzq" },
      { kind: "screen", id: "scr_c36vxl" },
      { kind: "screen", id: "scr_c1cqh7" },
    ] },
    { kind: "section", id: "sec_dcyvxh", children: [
      { kind: "screen", id: "scr_9yn99i" },
      { kind: "screen", id: "scr_e83lma" },
      { kind: "screen", id: "scr_kv6lds" },
      { kind: "screen", id: "scr_4npjbu" },
    ] },
    { kind: "section", id: "sec_5bzho2", children: [
      { kind: "screen", id: "scr_il93d5" },
      { kind: "screen", id: "scr_tt4b52" },
      { kind: "screen", id: "scr_8qlowz" },
      { kind: "screen", id: "scr_0bqw3s" },
      { kind: "screen", id: "scr_qlccqx" },
      { kind: "screen", id: "scr_zob9u7" },
      { kind: "screen", id: "scr_au3xjp" },
      { kind: "screen", id: "scr_tiz0d1" },
      { kind: "screen", id: "scr_6zm0m0" },
    ] },
    { kind: "section", id: "sec_z8y2qt", children: [
      { kind: "screen", id: "scr_wtecss" },
      { kind: "screen", id: "scr_193j2f" },
      { kind: "screen", id: "scr_zuewe3" },
      { kind: "screen", id: "scr_feq1sx" },
      { kind: "screen", id: "scr_utc5sc" },
      { kind: "screen", id: "scr_69qofc" },
    ] },
    { kind: "section", id: "sec_e6dn01", children: [
      { kind: "screen", id: "scr_spxecj" },
      { kind: "screen", id: "scr_o0ot1b" },
    ] },
  ],
}
